import {Component, Input, OnInit} from '@angular/core';
import {types} from '../../providers/data';
import {Frame} from '../../providers/models';

@Component({
  selector: 'app-item',
  templateUrl: './item.component.html',
  styleUrls: ['./item.component.css']
})
export class ItemComponent implements OnInit {

  @Input('color') color;
  @Input('opacity') opacity;
  @Input('item') item: Frame;
  @Input('time_actual') time_actual;
  type_title;
  constructor() {
  }

  ngOnInit() {
    types.forEach((item: Item) => {
      if ((this.item.tipo === item.type) || this.block_compare(this.item.tipo.toString(), item.type)) {
        if (!this.color) {
          this.color = item.color;
        }
        this.type_title = item.type_title;
      }
    });
  }

  block_compare(tipo, type) {
    return (tipo.substr(0, tipo.length - 5) === type);
  }

  getDisplayName() {
    if (this.item.tipo === 'news-frame' || this.item.tipo === 'news-frameblock') {
      if (this.item.idTipo === 9) {
        return 'Noticias (manual)';
      }
      const separator = this.item.nombre ? this.item.nombre.indexOf(':') : -1;
      return separator >= 0 ? this.item.nombre.substring(0, separator) : this.item.nombre;
    }
    return this.item.nombre;
  }

}

interface Item {
  id?;
  type?;
  type_title?;
  title?;
  color?;
  time?;
  fijo?;
}



// WEBPACK FOOTER //
// ./src/app/admin/item/item.component.ts